(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
// keep accordion folds open when somebody typing in
  if (Shopify.designMode && !window.theme?.customizerHandleDetails) {
    window.theme = window.theme || {};
    window.theme.customizerHandleDetails = (e) => { if (e.target.tagName === 'DETAILS') e.target.open = true; };
    document.addEventListener('shopify:block:select', window.theme.customizerHandleDetails); 
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

  //Copied from Utils function
  function getCookie(name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      // eslint-disable-next-line eqeqeq
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      // eslint-disable-next-line eqeqeq
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function updateAllProductGridFavouritesIcon(){
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function(swat) {
      // get all saved lists first and loop through each list's products to get ID and to update Heart icon display.
      swat.fetchLists({
        callbackFn: function(lists) {
          if (lists.length > 0) {
            lists.forEach(function(list) {
              if (list.listcontents.length > 0) {
                list.listcontents.forEach(function(product) {
                  const elements = document.querySelectorAll('p[data-product-id="'+product.empi+'"]');
                  elements.forEach(function (ele) {
                    ele.classList.remove('show-blank');
                    ele.classList.add('show-filled');
                    let child = ele.querySelectorAll('path.remove-product-from-wishlist[data-product-id="'+product.empi+'"]');
                    child[0].setAttribute("data-parent-id",list.lid);
                  });
                });
              }
            });
          }
        },
        errorFn: function(xhrObj) {
          console.error(xhrObj);
        }
      });
    });
  }

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    let url = productRecommendationsSection.dataset.url;

    let swymPromise = new Promise((resolve, reject) => {
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(function(swat) {
        swat.fetch( function(r) {
          if(r.length > 0){
            r.forEach(function(item) {
              resolve(item.empi);
            });
          }else{
            resolve(null);
          }
        });
      });
    });

    swymPromise.then((favourites_product_id) => {
      let recently_viewed_product_id = getCookie('recently_viewed_product_id');
      if (recently_viewed_product_id != '' && recently_viewed_product_id !== null) {
        // get product id from recently viewed product cookie
        url = url + recently_viewed_product_id;
      } else if (favourites_product_id !== null) {
        // use product id from favourites promise
        url = url + favourites_product_id;
      } else {
        // get product id from section.settings
        url = url + productRecommendationsSection.dataset.settingsProductId;
      }

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
          updateAllProductGridFavouritesIcon();
        })
        .catch(e => {
          console.error(e);
        });
    });


  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
